import {
  SET_JEWELLERY_COIN_PRICE,
  SET_JCP_LIVE_QUOTE_TABLE,
  SET_LATEST_PUBLISHED_JCP,
} from '../constants/JewelleryCoinPrice';

const initState = {
  jewelleryCoinPrice: undefined,
  jewelleryCoinPriceForm: undefined,
  jcpLiveQuoteTable: undefined,
  latestPublishedJcp: undefined,
};

const jewelleryCoinPrice = (state = initState, action) => {
  switch (action.type) {
    case SET_JEWELLERY_COIN_PRICE:
      let jewelleryCoinPriceForm = [];
      for (const type in action.jewelleryCoinPrice) {
        jewelleryCoinPriceForm.push({
          name: [type],
          value: action.jewelleryCoinPrice[type],
        });
      }
      return {
        ...state,
        jewelleryCoinPrice: action.jewelleryCoinPrice,
        jewelleryCoinPriceForm,
      };
    case SET_JCP_LIVE_QUOTE_TABLE:
      return {
        ...state,
        jcpLiveQuoteTable: action.jcpLiveQuoteTable,
      };
    case SET_LATEST_PUBLISHED_JCP:
      return {
        ...state,
        latestPublishedJcp: action.latestPublishedJcp,
      };
    default:
      return state;
  }
};

export default jewelleryCoinPrice;
